import React, { component } from 'react';
import styled from 'styled-components';
import identifyErrorMenssage from "../../services/identifyErrorMenssage";
import Button from '../button/button_v2';

import { ModalBody, ModalTitle } from "./styles";

import { store } from "react-notifications-component";

import api from '../../services/api';

import PlanilhaDropzone, { formatFileSize } from "../planilha-dropzone";


import ModalPassword from './modal_password';
import ModalText from './modalText';
import ModalAlert from './modalGeneric';
import { logout } from '../../services/auth';
import Modal from '.';
import IconHelp from '../../assets/icons/help';
import { theme } from '../../styles/theme';

export const USER = "@userinfo";

// Certificado A1: o navegador nem sempre preenche o mime do .pfx/.p12, entao as
// extensoes entram junto para o arquivo nao ser rejeitado na selecao.
const CERTIFICADO_ACCEPT = {
    'application/x-pkcs12': ['.pfx', '.p12'],
};

const CERTIFICADO_MAX_SIZE = 3098486; // ~3MB

const AjudaCertificado = styled.button`
    all: unset;

    margin-top: 16px;

    display: flex;
    align-items: center;
    gap: 6px;

    cursor: pointer;
    font-size: 13px;
    color: ${theme.colors.blue.Azul_link};
`;


class ModalNew extends React.Component {
    constructor(props) {
        super(props);
    }

    state = {
        arquivo: null,
        // File escolhido no dropzone, ainda nao lido: o certificado so e
        // processado quando o usuario confirma no "Salvar".
        arquivoSelecionado: null,
        file: [],
        textFile: "",
        isValidate: false,
        showModal: false,
        showModalText: false,
        showModalBlock: false,

    };
    componentDidMount() {

    }

    validaCertificado = async (file, password) => {
        if (this.props.cpf) {
            if (file && this.state.isValidate == false && password) {
                const payload = {
                    certificado: file,
                    cpf: this.props.cpf,
                    senha: password,
                }
                try {

                    let user = JSON.parse(localStorage.getItem(USER));
                    if (user.contrato) {
                        if (user.contrato.agro_plan_functions) {
                            let isBlock = false;

                            user.contrato.agro_plan_functions.map((e) => {

                                if (e.agro_plans_function.id === 9) {
                                    if (e.status === 0) {
                                        isBlock = true;
                                    }
                                }
                            });

                            if (isBlock === true) { 
                                this.closeModalPassword();
                                store.addNotification({
                                    title: "Erro!",
                                    message: `A função de assinatura digital não está liberada para seu plano!`,
                                    type: "danger",
                                    insert: "top",
                                    container: "top-right",
                                    animationIn: ["animated", "fadeIn"],
                                    animationOut: ["animated", "fadeOut"],
                                    dismiss: {
                                        duration: 4000,
                                        onScreen: true
                                    }
                                });
                            } else { 
                                const response = await api.post(`/sign/digital`, payload);
                                if (response) {
                                    this.setState({isValidate: true});
                                }

                                store.addNotification({
                                    title: "Sucesso!",
                                    message: `${response.data.data.msg}`,
                                    type: "success",
                                    insert: "top",
                                    container: "top-right",
                                    animationIn: ["animated", "fadeIn"],
                                    animationOut: ["animated", "fadeOut"],
                                    dismiss: {
                                        duration: 4000,
                                        onScreen: true
                                    }
                                });

                                this.props.onHide(password);
                            }
                        } else {
                            logout();
                            window.location = '/login';
                        }
                    } else {
                        logout();
                        window.location = '/login';
                    }
                } catch (error) {
                    this.closeModalPassword();
                    store.addNotification({
                        title: "Erro!",
                        message: identifyErrorMenssage(error),
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 4000,
                            onScreen: true
                        }
                    });
                }
            }
        } else {
            store.addNotification({
                title: "Erro!",
                message: `Informe o CPF!`,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    };

    notificar = (message) => {
        store.addNotification({
            title: "Erro!",
            message,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: { duration: 4000, onScreen: true },
        });
    };

    onSelectCertificate = (selectedFile) => {
        if (!selectedFile) return;

        this.setState({
            arquivoSelecionado: selectedFile,
            arquivo: {
                nome: selectedFile.name,
                tamanho: formatFileSize(selectedFile.size),
                extensao: selectedFile.name.split('.').pop() || '',
            },
        });
    };

    salvarCertificadoSelecionado = () => {
        const selectedFile = this.state.arquivoSelecionado;
        if (!selectedFile) return;

        const user = JSON.parse(localStorage.getItem(USER));

        if (user.contract_software_id === 6) {
            this.setState({ showModalBlock: true });
            return;
        }

        if (!this.props.cpf) {
            this.notificar('Informe o CPF!');
            return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(selectedFile);
        reader.onload = (e) => {
            this.setState({
                file: e.target.result,
                textFile: e.target.result,
                showModal: true,
            });
        };
    };

    deleteFile = () => {
        this.setState({ arquivo: null, arquivoSelecionado: null, file: [], textFile: '', isValidate: false });
    };

    openModalText = () => {
        this.setState({ showModalText: true });
    }
    modalTextClose = () => {
        this.setState({ showModalText: false });
    }

    updatePassword = (e) => {
        this.validaCertificado(this.state.file, e);
        this.setState({showModal: false});
    }
    
    closeModalPassword = () => {
        // Cancelar a senha descarta tambem o File escolhido: sem isso o cartao
        // sumia mas o Salvar continuava ativo com um arquivo invisivel.
        this.setState({ showModal: false, arquivo: null, arquivoSelecionado: null, textFile: '' });
    }


    render() {
        return (
            <>
                <Modal
                    {...this.props}
                    align='center' // center, end, start
                    justify='center' // center, end, start
                    responsive
                    width='60%'
                >
                    <ModalTitle> Upload do certificado digital </ModalTitle>

                    <ModalBody>
                        <PlanilhaDropzone
                            descricao="O upload do certificado é necessário caso deseje assinar sua receita digitalmente."
                            chamada="Arraste o certificado aqui"
                            legenda="PFX ou P12, até 3 MB"
                            accept={CERTIFICADO_ACCEPT}
                            maxSize={CERTIFICADO_MAX_SIZE}
                            arquivo={this.state.arquivo}
                            onSelect={this.onSelectCertificate}
                            onRemove={this.deleteFile}
                            onReject={(motivo) => this.notificar(motivo)}
                        />

                        <div style={{ width: '100%', marginTop: '16px' }}>
                            <Button
                                width='100%'
                                height='50px'
                                value='SALVAR'
                                outline={false}
                                disabled={!this.state.arquivoSelecionado}
                                onClick={() => this.salvarCertificadoSelecionado()}
                                loading={false}
                            />
                        </div>

                        <AjudaCertificado onClick={this.openModalText}>
                            <IconHelp fill="#5DA8FD" cursor="pointer" />
                            O que é um certificado digital?
                        </AjudaCertificado>

                        <ModalPassword
                            text={"Precisamos da sua senha para validar a autenticidade do certificado. Para sua segurança, essa senha não ficará salva em nossos servidores."}
                            show={this.state.showModal}
                            update={(e) => this.updatePassword(e)}
                            onHide={this.closeModalPassword}
                            size='md'
                        />
                        <ModalText
                            show={this.state.showModalText}
                            onHide={this.modalTextClose}
                            text={"Certificado digital é um arquivo eletrônico que serve como identidade virtual para uma pessoa física ou jurídica. Ele serve para agilizar a assinatura conferindo legitimidade aos documentos digitais, que passam a possuir validade jurídica. Esse certificado deve ser emitido por uma Autoridade Certificadora vinculada ao ICP-Brasil"}
                            btnOk={false}
                            size='md'
                        />  

                        <ModalAlert
                            show={this.state.showModalBlock}
                            onHide={false}
                            size='md'
                        >
                            <h4 style={{
                                textAlign: 'center'
                            }}>Essa é uma função exclusiva para clientes AgroReceita</h4>

                            <p style={{
                                textAlign: 'center',
                                marginTop: '20px',
                            }}>
                                Para não comprometer o controle de suas receitas agronômicas essa função só pode ser utilizada nos planos Light e Pro. Entre em contato com nosso suporte e faça o upgrade do seu plano para desbloquear esse recurso.
                            </p>

                            <div className="button-finish" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: '40px' }}>
                                <Button
                                    width='296px'
                                    height='50px'
                                    value='ENTENDI'
                                    outline={false}
                                    disabled={false}
                                    onClick={() => this.setState({ showModalBlock: false })}
                                    loading={false}
                                />
                            </div>
                        </ModalAlert>
                    </ModalBody>
                </Modal>
            </>
        );
    }
}
export default ModalNew;